

export const zh: { [key: string]: { [key: string]: string } } = {

    common: {

        register: "Registro",

        login: "Entrar",

        more: "更多",

        less: "收起",

    },

    downloadPlatform: {

        title: "选择安装方式",

        pwa: "安装 PWA",

        apk: "下载 APK",

        pwaNotSupported: "此浏览器不支持安装",

        footer: "请选择您想要的安装方式"

    },

    appStoreInstall: {

        title: "选择安装方式",

        pwa: "安装 PWA",

        iosProfile: "安装 iOS 配置文件",

        pwaNotSupported: "此浏览器不支持安装",

        iosProfileFailed: "无法获取 iOS 配置文件下载链接",

        iosProfileInstructions: "请按照以下步骤安装 iOS 配置文件"

    },

    download: {

        pwaDownloadInstructions: "在 Safari 中点击分享，然后选择“添加到主屏幕”"

    },

    appStore: {

        action: "获取",

        inAppPurchases: "App 内购买项目",

        learnMore: "了解更多",

        yes: "是",

        ad: "广告",

        languageSwitch: "EN",

        statsYears: "岁",

        statsAgeRating: "年龄分级",

        statsDeveloper: "开发者",

        developerName: "Yousician Ltd",

        developerRole: "开发者",

        ratingsMostHelpful: "最有用的评论",

        ratingsSeeAll: "查看所有评论",

        reviewR1Title: "关于我的体验",

        reviewR1Date: "3 月 26 日",

        reviewR1Author: "Gataonly",

        reviewR2Title: "最好用的调音 App",

        reviewR2Date: "3 月 12 日",

        reviewR2Author: "MusicLover92",

        whatsNewVersion: "版本 7.97.0",

        whatsNewUpdatedAt: "1 天前",

        whatsNewBody: "此更新包含一些小的改进和错误修复。",

        privacyTitle: "App 隐私",

        privacyIntroPrefix: "开发者",

        privacyIntroMiddle: "指出，此 App 的隐私处理可能包括如下所述的数据。更多信息，请参阅",

        privacyIntroSuffix: "。",

        privacyPolicyLink: "开发者隐私政策",

        privacyTrackTitle: "用于追踪你的数据",

        privacyTrackDescription: "以下数据可能会用于在其他公司拥有的 App 和网站中追踪你：",

        privacyLinkedTitle: "与你关联的数据",

        privacyLinkedDescription: "以下数据可能会被收集并与你的身份关联：",

        privacyNotLinkedTitle: "未与你关联的数据",

        privacyNotLinkedDescription: "以下数据可能会被收集，但不会与你的身份关联：",

        privacyDisclaimer: "隐私处理方式可能因你使用的功能或年龄等因素而异。",

        privacyItemLocation: "位置",

        privacyItemIdentifiers: "标识符",

        privacyItemUsageData: "使用数据",

        privacyItemDiagnostics: "诊断",

        privacyItemPurchases: "购买项目",

        accessibilityTitle: "辅助功能",

        accessibilityBody: "开发者尚未指明此 App 支持哪些辅助功能。",

        informationTitle: "信息",

        informationProvider: "提供商",

        informationSize: "大小",

        informationCategory: "类别",

        informationCompatibility: "兼容性",

        informationCompatibilityValue: "在此 iPhone 上可用",

        informationLanguages: "语言",

        informationLanguagesValue: "英语及其他 10 种语言",

        informationAgeRating: "年龄分级",

        informationAgeRatingValue: "4+ 偶尔/轻微的性内容",

        informationInAppPurchases: "App 内购买项目",

        informationCopyright: "版权",

        informationCopyrightValue: "© Yousician Ltd",

        informationLinkDeveloperWebsite: "开发者网站",

        informationLinkPrivacyPolicy: "隐私政策",

        informationLinkLicenceAgreement: "许可协议",

        relatedMoreByDeveloper: "Yousician Ltd 的更多 App",

        relatedYouMightAlsoLike: "你可能还喜欢",

        relatedYousicianName: "Yousician：学习与弹吉他",

        relatedYousicianSubtitle: "吉他、贝斯与演唱课程",

        relatedPianoName: "Piano by Yousician",

        relatedPianoSubtitle: "钢琴课程与歌曲",

        relatedTcgName: "TCG 卡牌收藏扫描器",

        relatedTcgSubtitle: "卡牌扫描器：价格与整理",

        relatedDoubletuneName: "吉他调音器 - 尤克里里与贝斯",

        relatedDoubletuneSubtitle: "DoubleTune：贝斯、大提琴调音……",

        relatedGuitarTunerEasyName: "吉他调音器 - 轻松调和弦",

        relatedGuitarTunerEasySubtitle: "原声尤克里里、电贝斯",

        footerDisclaimer: "GuitarTuna 是 Yousician Ltd 的商标。本页面仅为演示用途的 UI 复刻。",

        tabBarToday: "今天",

        tabBarGames: "游戏",

        tabBarApps: "App",

        tabBarArcade: "Arcade",

        tabBarSearch: "搜索",

        tabBarLabel: "App Store 导航",

        casino: "赌场",

    },

};

